<p>Congrats, your notifier has been successfully configured!</p>
<a
  href="/projects/{{ project.id }}/edit"
  target="_self"
  class="btn btn--success btn--default"
  (click)="dismissAndFollow($event)"
>
  Name first project
</a>
